import DatePart from './DatePart'
export default DatePart
